import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBellLogLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11316_19920)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M47.5 85.5934L0.569871 95.3705L9.44377 12.0545L47.5 16.4456V85.5934Z",
				fill: "white",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 11.5L61 7V81.375L5 92L9 11.5Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.5 87.3922V11.4113L64.5 0.607769V76.5887L9.5 87.3922Z",
				fill: "white",
				stroke: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_11316_19920)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M22.6781 70.9063L19.2832 72.6478L20.0378 68.9076C19.5408 68.082 19.2816 67.0767 19.2832 65.9811C19.2832 62.2991 22.1558 58.5043 25.6996 57.5048C29.2433 56.5054 32.1159 58.6799 32.1159 62.3619C32.1159 66.0439 29.2433 69.8387 25.6996 70.8382C24.6456 71.1371 23.6076 71.1605 22.6781 70.9063ZM22.8642 69.4452L23.2832 69.5603C24.0265 69.7635 24.8567 69.7444 25.6996 69.5048C26.7148 69.2185 27.7072 68.6258 28.5514 67.8017C29.3955 66.9776 30.0534 65.9591 30.4419 64.875C30.8305 63.7909 30.9321 62.6899 30.734 61.7112C30.536 60.7325 30.0471 59.92 29.3292 59.3766C28.6113 58.8332 27.6967 58.5832 26.701 58.6582C25.7053 58.7333 24.6732 59.13 23.7352 59.7982C22.7973 60.4664 21.9956 61.376 21.4316 62.4122C20.8675 63.4483 20.5665 64.5644 20.5665 65.6192C20.5665 66.5085 20.775 67.3057 21.1696 67.9598L21.3936 68.3319L20.9733 70.4151L22.8642 69.4452ZM22.4914 65.0763L23.7747 64.7144C23.7747 65.2448 23.9775 65.6963 24.3385 65.9696C24.6995 66.2429 25.1891 66.3155 25.6996 66.1715C26.2101 66.0275 26.6997 65.6787 27.0607 65.2019C27.4217 64.725 27.6245 64.1591 27.6245 63.6286L28.9078 63.2667C28.9078 64.1508 28.5698 65.0939 27.9681 65.8887C27.3665 66.6836 26.5504 67.2649 25.6996 67.5048C24.8487 67.7448 24.0327 67.6238 23.4311 67.1683C22.8294 66.7129 22.4914 65.9604 22.4914 65.0763Z",
					fill: "black"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip2_11316_19920)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M29.8327 40.7238C29.8325 39.5351 29.4502 38.4883 28.7463 37.7497C28.0425 37.011 27.0574 36.6229 25.9476 36.6468C24.8379 36.6708 23.6669 37.1055 22.6208 37.8819C21.5747 38.6583 20.7134 39.732 20.1736 40.9324C19.6339 42.1327 19.4466 43.391 19.6415 44.5074C19.8365 45.6238 20.4025 46.5342 21.2497 47.0942C22.0969 47.6543 23.1767 47.8317 24.3176 47.5984C25.4586 47.365 26.5952 46.7343 27.5472 45.8064L28.2594 46.7149C27.2059 47.7438 25.9668 48.4829 24.6996 48.8382C21.1558 49.8376 18.2832 47.6631 18.2832 43.9811C18.2832 40.2991 21.1558 36.5043 24.6996 35.5048C28.2433 34.5054 31.1159 36.6799 31.1159 40.3619V41.3619C31.116 41.8611 30.962 42.3905 30.6766 42.8725C30.3911 43.3545 29.9893 43.7637 29.53 44.0399C29.0708 44.316 28.5784 44.4447 28.1252 44.4069C27.672 44.3691 27.2818 44.1669 27.012 43.83C26.5838 44.4134 26.0361 44.8923 25.4347 45.2089C24.8333 45.5256 24.2039 45.6667 23.622 45.6151C23.0401 45.5636 22.5305 45.3217 22.1544 44.9185C21.7783 44.5153 21.5518 43.968 21.5019 43.3422C21.4521 42.7164 21.5812 42.0389 21.8736 41.391C22.166 40.7431 22.6093 40.1523 23.1503 39.6897C23.6912 39.2272 24.3069 38.9124 24.9232 38.7833C25.5395 38.6542 26.1302 38.7162 26.6245 38.962L27.9078 38.6V42.2667C27.9078 42.5319 28.0092 42.7577 28.1897 42.8943C28.3701 43.0309 28.615 43.0673 28.8702 42.9953C29.1255 42.9233 29.3703 42.7489 29.5508 42.5104C29.7313 42.272 29.8327 41.9891 29.8327 41.7238V40.7238ZM24.6996 40.1715C24.1891 40.3155 23.6994 40.6643 23.3385 41.1412C22.9775 41.6181 22.7747 42.184 22.7747 42.7144C22.7747 43.2448 22.9775 43.6963 23.3385 43.9696C23.6994 44.2429 24.1891 44.3155 24.6996 44.1715C25.2101 44.0275 25.6997 43.6787 26.0607 43.2019C26.4217 42.725 26.6245 42.1591 26.6245 41.6286C26.6245 41.0982 26.4217 40.6467 26.0607 40.3734C25.6997 40.1002 25.2101 40.0275 24.6996 40.1715Z",
					fill: "#4F49BA"
				})
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 40,
				height: 1,
				transform: "matrix(0.978148 -0.207912 0 1 16 24.3164)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 1,
				transform: "matrix(0.978148 -0.207912 0 1 16 28.6532)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 21,
				cy: 14,
				r: 1,
				fill: "#4F49BA",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 30,
				cy: 12,
				r: 1,
				fill: "#4F49BA",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 41.5408,
				cy: 9.75854,
				r: 1,
				fill: "#4F49BA",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 53.3298,
				cy: 6.81335,
				r: 1,
				fill: "#4F49BA",
				fillOpacity: .12
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.9455 40.7495C36.51 39.5433 38.113 37.1768 40.0096 37.3598C42.3803 37.5886 31.8814 44.1391 35.9455 42.9929C40.0096 41.8467 44.0737 36.9615 45.767 36.9326C47.4604 36.9037 40.0096 43.6415 46.1057 39.2301C50.9826 35.7009 54.0081 33.9104 54.9112 33.4563",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36 67.0839C38.7085 64.025 43.4103 58.1806 40.5502 59.274C36.975 60.6408 37.3001 67.9297 41.2002 65.5435C42.4508 64.7784 44.002 63.6079 45.4254 62.3922M45.4254 62.3922C48.4414 59.8164 50.8836 57.0376 48.6756 57.4826C45.4254 58.1376 42.8253 60.955 45.4254 62.3922ZM45.4254 62.3922C45.8588 62.8971 47.1155 63.7913 48.6756 63.3292C50.6257 62.7516 57.126 53.7486 54.2008 55.5382C51.8607 56.9699 53.2258 60.2377 54.2008 61.6926",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.3298 6.81337C52.9964 3.31337 53.6911 -0.0588996 46.8298 1.31336C45.8298 1.51336 44.3298 1.81337 45.3298 2.81337",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.5408 9.7585C41.2075 6.2585 41.9021 1.8862 35.0408 3.25849C32.5409 3.75851 33.0407 4.75848 33.0408 5.25848",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.0408 11.7585C28.5 7.25849 29 3.99999 25.5 4.5C22.9761 4.86056 23 6.5 23 7.00001",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.0408 13.3091C19.4999 8.8091 20.5 5.49993 17 5.99994C14.4761 6.3605 14.9999 7.99994 14.9999 8.49995",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M94.5 68C94.5 68.1037 94.4524 68.2551 94.2554 68.4576C94.0567 68.6621 93.7382 68.8834 93.2841 69.1094C92.3777 69.5605 91.0338 69.9809 89.332 70.3392C85.9367 71.054 81.2228 71.5 76 71.5C70.7772 71.5 66.0633 71.054 62.668 70.3392C60.9662 69.9809 59.6223 69.5605 58.7159 69.1094C58.2618 68.8834 57.9433 68.6621 57.7446 68.4576C57.5476 68.2551 57.5 68.1037 57.5 68C57.5 67.8963 57.5476 67.7449 57.7446 67.5424C57.9433 67.3379 58.2618 67.1166 58.7159 66.8906C59.6223 66.4395 60.9662 66.0191 62.668 65.6608C66.0633 64.946 70.7772 64.5 76 64.5C81.2228 64.5 85.9367 64.946 89.332 65.6608C91.0338 66.0191 92.3777 66.4395 93.2841 66.8906C93.7382 67.1166 94.0567 67.3379 94.2554 67.5424C94.4524 67.7449 94.5 67.8963 94.5 68Z",
				fill: "white",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M95.5 66.378C95.5 67.9363 94.0744 69.105 92.5464 68.7994L86.4163 67.5734C79.5402 66.1981 72.4598 66.1981 65.5837 67.5734L59.4536 68.7994C57.9256 69.105 56.5 67.9363 56.5 66.378C56.5 65.9305 56.6216 65.4913 56.8519 65.1076L57.4287 64.1461C58.1297 62.9779 58.5 61.641 58.5 60.2786V50.0689C58.5 39.2081 66.3859 30.5 76 30.5C85.6141 30.5 93.5 39.2081 93.5 50.0689V60.2786C93.5 61.641 93.8703 62.9779 94.5713 64.1461L95.1481 65.1076C95.3784 65.4913 95.5 65.9305 95.5 66.378Z",
				fill: "white",
				stroke: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68 49.7236C68 49.3912 68.3499 49.1749 68.6472 49.3236L69.5279 49.7639C69.8251 49.9125 70.1749 49.9125 70.4721 49.7639L71.3528 49.3236C71.6501 49.1749 72 49.3912 72 49.7236C72 49.893 71.9043 50.0479 71.7528 50.1236L70.8944 50.5528C70.3314 50.8343 69.6686 50.8343 69.1056 50.5528L68.2472 50.1236C68.0957 50.0479 68 49.893 68 49.7236Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M79 49.7236C79 49.3912 79.3499 49.1749 79.6472 49.3236L80.5279 49.7639C80.8251 49.9125 81.1749 49.9125 81.4721 49.7639L82.3528 49.3236C82.6501 49.1749 83 49.3912 83 49.7236C83 49.893 82.9043 50.0479 82.7528 50.1236L81.8944 50.5528C81.3314 50.8343 80.6686 50.8343 80.1056 50.5528L79.2472 50.1236C79.0957 50.0479 79 49.893 79 49.7236Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 75.5,
				cy: 57,
				rx: 1.5,
				ry: 1,
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M72.0322 30.4892C73.3088 30.169 74.6367 30 75.9999 30C77.3632 30 78.691 30.169 79.9676 30.4892C79.7168 28.5213 78.036 27 75.9999 27C73.9638 27 72.2831 28.5213 72.0322 30.4892Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71 68.6667L72.5637 68.4582C74.8445 68.1541 77.1555 68.1541 79.4363 68.4582L81 68.6667V69C81 71.7614 78.7614 74 76 74C73.2386 74 71 71.7614 71 69V68.6667Z",
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M89.5 29.5L93.1706 30.9683C93.6101 31.1441 93.582 31.7754 93.1286 31.9114L90.413 32.7261C90.0269 32.8419 89.9295 33.3436 90.2443 33.5955L92 35",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M76.5 7.5L80.7189 7.17547C81.254 7.13431 81.4692 7.85043 81.0001 8.11108L74.7867 11.5629C74.4438 11.7534 74.4438 12.2466 74.7867 12.4371L78.5 14.5",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M84 14.6809L87.8837 14.1963C88.3688 14.1358 88.6435 14.7357 88.2809 15.0634L85.5858 17.499C85.2972 17.7598 85.4038 18.2357 85.7761 18.3485L89.6425 19.5195",
				stroke: "black",
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_11316_19920",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 96,
				height: 96,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_11316_19920",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "matrix(0.962455 -0.27144 0 1 18 58.343)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip2_11316_19920",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white",
				transform: "matrix(0.962455 -0.27144 0 1 17 36.343)"
			})
		})
	] })]
});
export default SvgBellLogLine;
